import { gql } from 'graphql-request'

export const QueryBlockFeatureList = gql`
  fragment FragmentBlockFeatureList on BlockFeatureListModelRecord {
          __typename
          id
          title
          description {
            value
          }
          featureList {
            ...FragmentFeatureCardBlock
          }
        }
`
export const BlockFeatureList = {
  __typename: 'BlockFeatureList',
  fragmentName: 'FragmentBlockFeatureList',
  fragmentQuery: QueryBlockFeatureList,
  fragments: ['FragmentNavigationItem', 'FragmentFeatureCardBlock']
}
